import { MENU_KEY_ROUTES } from "src/constants";
import { TopupListing, TopupDetails } from "src/Modules/Topup/pages";
export const topupRoutes = {
  path: MENU_KEY_ROUTES["TopUp"],
  children: [
    {
      index:true,
      element: <TopupListing/>
    },
    {
      path:":code",
      element:<TopupDetails/>
    }
  ],
};